import LocationalState, {AnchorPoint, LocationalConfidence, LocationalRoadObject,} from "./LocationalState";
import {AnyAction} from "redux";
import {ServerHolder} from "./components/locational2";
import {ThunkDispatch} from "redux-thunk";
import {LatLng} from "leaflet";
import {LocalizeResult} from "../../../integration/server/server-services";
import {RoadSegment} from "../../../integration/representation/road-segment";
import {batch} from "react-redux";
import {SidePositionEdit} from "../contract-features-3/domain";
import {handleError} from "../../actions/actions";
import {LaneUpdate} from "../../../integration/representation/lane";
import {Locational} from "../../../integration/representation/feature";
import {VegRespons} from "../../../integration/nvdbapi/nvdbapi";
import {getRefLink} from "../../../locationalUtilities";

export enum LocationalActionType {
    SET_AUTO_LOCALIZE_MODAL_VISIBILITY,
    SET_CURRENT_USER,
    SET_ROAD_OBJECT_TYPES,
    SET_ROAD_OBJECTS,
    SET_SELECTED_TYPES,
    SET_SELECTED_ROAD_OBJECTS,
    SET_ROAD_REFS,
    SET_SELECTED_ROAD_REF,
    SET_LOCATIONAL_IN_LANE_MODAL,
    UPDATE_ROADOBJECTS,
    ADD_TO_PROGRESS_GOAL,
    ADD_TO_PROGRESS,
    SET_ACTIVE_CONFIDENCE_FILTERS,
    SET_DISPLAY_SYNCHRONIZED_OBJECTS,
    SET_USE_ANCHORS,
    SET_LISTEN_FOR_ANCHORPOINT,
    SET_ANCHOR_POINT,
    TOGGLE_SKRIV_LOCATIONALS,
    SET_DATACATALOG,
    FETCHING_POINTS_FROM_REFERENCE,
    SET_FEATURE_IN_DETAILS_MODAL,
    SET_SELECTED_OVERWRITE_ROAD_CATEGORY,
    SET_SELECTED_OVERWRITE_ROAD_USER_GROUP,
}

export type LocationalThunk = (dispatch: ThunkDispatch<LocationalState, ServerHolder, AnyAction>, getState: () => LocationalState, serverHolder: ServerHolder) => void


const showErrorMessage = (message: string): LocationalThunk => (dispatch, getState, serverHolder) => {
    serverHolder.scope.$applyAsync(() =>
        serverHolder.server.messages.danger(message)
    );
};
const showWarningMessage = (message: string): LocationalThunk => (dispatch, getState, serverHolder) => {
    serverHolder.scope.$applyAsync(() =>
        serverHolder.server.messages.warning(message)
    );
};
const showInfoMessage = (message: string): LocationalThunk => (dispatch, getState, serverHolder) => {
    serverHolder.scope.$applyAsync(() =>
        serverHolder.server.messages.info(message)
    );
};

export type InitLocational = () => LocationalThunk;
export const initLocational: InitLocational = () => (dispatch, getState, serverHolder) => {
    serverHolder.security.ensureCurrentUser()
        .then(user => {
            dispatch({
                type: LocationalActionType.SET_CURRENT_USER,
                currentUser: user
            });
        });

    dispatch({
        type: LocationalActionType.SET_DATACATALOG,
        datacatalog: serverHolder.datacatalog
    });

    serverHolder.server.readContract(serverHolder.contractId)
        .then(contract => {
            dispatch({
                type: LocationalActionType.SET_SELECTED_OVERWRITE_ROAD_CATEGORY,
                category: contract.roadCategory ?? 'null'
            })
        })


};

export type ToggleSynchronizedObjects = () => LocationalThunk;
export const toggleSynchronizedObjects: ToggleSynchronizedObjects = () => async (dispatch, getState, serverHolder) => {
    let state = getState();
    dispatch({
        type: LocationalActionType.SET_DISPLAY_SYNCHRONIZED_OBJECTS,
        show: !state.displaySynchronizedObjects
    });
};
export type ToggleConfidenceFilter = (filter: LocationalConfidence) => LocationalThunk;
export const toggleConfidenceFilter: ToggleConfidenceFilter = (filter) => async (dispatch, getState, serverHolder) => {
    let state = getState();

    let activeConfidenceFilters = state.activeConfidenceFilters.slice(0);   // clone
    if (activeConfidenceFilters.some(f => f === filter)) {
        activeConfidenceFilters = activeConfidenceFilters.filter(f => f !== filter);
    } else {
        activeConfidenceFilters.push(filter);
    }

    dispatch({
        type: LocationalActionType.SET_ACTIVE_CONFIDENCE_FILTERS,
        activeConfidenceFilters
    });

};

export type GetRoadObjectTypeList = (contractId: string) => LocationalThunk;
export const getRoadObjectTypeList: GetRoadObjectTypeList = (contractId) => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: LocationalActionType.ADD_TO_PROGRESS_GOAL,
        progress: 1
    });
    try{
        let result = await serverHolder.server.getFeatureTypeSummary(contractId);

        dispatch({
            type: LocationalActionType.SET_ROAD_OBJECT_TYPES,
            roadObjectTypes: result
        });
    }
    catch(e){}

    dispatch({
        type: LocationalActionType.ADD_TO_PROGRESS,
        progress: 1
    });

};

export type GetRoadObjects = (contractId: string) => LocationalThunk;
export const getRoadObjects: GetRoadObjects = (contractId) => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: LocationalActionType.ADD_TO_PROGRESS_GOAL,
        progress: 1
    });
    try {
        let result = await serverHolder.server.readFeatures(contractId, 'NVDB');
        dispatch({
            type: LocationalActionType.SET_ROAD_OBJECTS,
            roadObjects: result.features
        });
    }
    catch (e){}
    dispatch({
        type: LocationalActionType.ADD_TO_PROGRESS,
        progress: 1
    });
};

export type ToggleSelectedType = (typeId: number) => LocationalThunk;
export const toggleSelectedType: ToggleSelectedType = (typeId) => async (dispatch, getState, serverHolder) => {
    let selected = getState().selectedTypes.slice(0);   // clone
    if (selected.some(type => type === typeId)) {
        selected = selected.filter(type => type !== typeId);
    } else {
        selected.push(typeId);
    }

    dispatch({
        type: LocationalActionType.SET_SELECTED_TYPES,
        selectedTypes: selected
    })
};

export type ToggleSelectedRoadObject = (roId: string) => LocationalThunk;
export const toggleSelectedRoadObject: ToggleSelectedRoadObject = (roId) => async (dispatch, getState, serverHolder) => {
    const {selectedRoadObjects, roadObjects} = getState();
    let selected = selectedRoadObjects.slice(0);   // clone
    if (selected.some(ro => ro === roId)) {
        selected = selected.filter(ro => ro !== roId);
    } else {
        selected.push(roId);
    }

    dispatch(setSelectedRoadObjects(selected));

    if (selected.length > 0) {

        const refLinks: Record<string, string> = await Promise.all(roadObjects.filter(ro => selected.includes(ro.id))
          .map(feature => feature.locational.locationals.map(getRefLink)
            .filter(ref => Boolean(ref)))
          .reduce((prev, curr) => prev.concat(curr))
          .map(refLink => serverHolder.nvdbapi.getVegSystemReferanseFromRefLink(refLink).then((roadSysRefResult: VegRespons) => ({[refLink]: roadSysRefResult.vegsystemreferanse.kortform}))))
          .then(allRefResults => allRefResults.reduce((prev, curr) => ({...prev, ...curr}), {}));

        const featuresWithRoadSystemReferences = roadObjects.map(feature => {
            if (!selected.includes(feature.id)) {
                return feature;
            }
            return {
            ...feature,
            locational: {
                ...feature.locational,
                locationals: feature.locational.locationals.map(locational => ({
                        ...locational,
                        shortRoadSystemReference: refLinks[getRefLink(locational)] ?? undefined
                    }))
                }
            };
        });

        dispatch({
            type: LocationalActionType.SET_ROAD_OBJECTS,
            roadObjects: featuresWithRoadSystemReferences
        });
    }

};

export type UnselectRoadObjects = (roIds: string[]) => LocationalThunk;
export const unselectRoadObjects: UnselectRoadObjects = (roIds) => async (dispatch, getState, serverHolder) => {
    let selected = getState().selectedRoadObjects
        .slice(0)
        .filter(selectedRo => {
            return !roIds.some(roId => roId == selectedRo);
        })
    dispatch(setSelectedRoadObjects(selected))
}



export type SetSelectedRoadObjects = (ros: string[]) => LocationalThunk;
export const setSelectedRoadObjects: SetSelectedRoadObjects = (ros) => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: LocationalActionType.SET_SELECTED_ROAD_OBJECTS,
        selectedRoadObjects: ros
    })
};

export type GetRoadSegments = (southWestX: number, southWestY: number, northEastX: number, northEastY: number) => LocationalThunk;
export const getRoadSegments: GetRoadSegments = (southWestX: number, southWestY: number, northEastX: number, northEastY: number) => async (dispatch, getState, serverHolder) => {
    let result = await serverHolder.server.getRoadSegmentsInArea(southWestX, southWestY, northEastX, northEastY);

    if (result) {
        dispatch({
            type: LocationalActionType.SET_ROAD_REFS,
            roadSegments: result
        })
    }
};

export type SetSelectedRoadSegment = (roadSegment: RoadSegment) => LocationalThunk;
export const setSelectedRoadSegment: SetSelectedRoadSegment = (roadSegment) => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: LocationalActionType.SET_SELECTED_ROAD_REF,
        selectedRoadSegment: roadSegment
    });
    if(roadSegment){
        dispatch({
            type: LocationalActionType.SET_SELECTED_OVERWRITE_ROAD_CATEGORY,
            category: roadSegment.roadCategory
        });
    }
};

export type DisplayMissingDirectionMessage = (message: string) => LocationalThunk;
export const displayMissingDirectionMessage: DisplayMissingDirectionMessage = (message) => async (dispatch, getState, serverHolder) => {
    dispatch(
        showInfoMessage(message)
    );
}


export type OpenLaneModal = (locational: Locational) => LocationalThunk;
export const openLaneModal: OpenLaneModal = (locational) => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: LocationalActionType.SET_LOCATIONAL_IN_LANE_MODAL,
        locationalSelectedForLaneModal: locational
    })
};

export type CloseLaneModal = () => LocationalThunk;
export const closeLaneModal: CloseLaneModal = () => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: LocationalActionType.SET_LOCATIONAL_IN_LANE_MODAL,
        locationalSelectedForLaneModal: null
    })
};

export type SetOverwriteRoadCategory = (category: string) => LocationalThunk;
export const setOverwriteRoadCategory: SetOverwriteRoadCategory = (category) => dispatch => dispatch({
    type: LocationalActionType.SET_SELECTED_OVERWRITE_ROAD_CATEGORY,
    category
});

export type SetOverwriteRoadUserGroup = (type: string) => LocationalThunk;
export const setOverwriteRoadUserGroup: SetOverwriteRoadUserGroup = (group) => dispatch => dispatch({
    type: LocationalActionType.SET_SELECTED_OVERWRITE_ROAD_USER_GROUP,
    group
});

export type LocalizeRoadObjects = (roadObjects: LocationalRoadObject[], roadSegment: RoadSegment, startAnchor: LatLng, endAnchor: LatLng) => LocationalThunk;
export const localizeRoadObjects: LocalizeRoadObjects = (roadObjects, roadSegment, startAnchor, endAnchor) => async (dispatch, getState, serverHolder) => {

    dispatch({
        type: LocationalActionType.ADD_TO_PROGRESS_GOAL,
        progress: roadObjects.length
    });

    for (let roadObject of roadObjects) {
        serverHolder.server.localizeFeature2(serverHolder.contractId, roadObject.id, roadSegment, startAnchor, endAnchor).then(result => {
            dispatch({
                type: LocationalActionType.ADD_TO_PROGRESS,
                progress: 1,
            });

            handleLocalizeResult(result, dispatch);
        }, error => {
            dispatch({
                type: LocationalActionType.ADD_TO_PROGRESS,
                progress: roadObjects.length
            })
        });
    }
    dispatch(setAnchorPoint(AnchorPoint.start, null));
    dispatch(setAnchorPoint(AnchorPoint.end, null));
};

function handleLocalizeResult(result: LocalizeResult, dispatch: ThunkDispatch<LocationalState, ServerHolder, AnyAction>) {
    if (result.success) {
        dispatch({
            type: LocationalActionType.UPDATE_ROADOBJECTS,
            roadObjects: result.features,
        });
        dispatch(
            unselectRoadObjects(result.features.map(feature => feature.id))
        );
    } else {
        let responseMessage = result.message;
        if(typeof result.features[0] === 'object'){
            responseMessage = result.features[0].name + ": " + responseMessage;

            // if payload contains road objects, update to reflect what they are
            dispatch({
                type: LocationalActionType.UPDATE_ROADOBJECTS,
                roadObjects: result.features,
            });
        }
        dispatch(showWarningMessage(responseMessage));
    }
}

export type LocalizeRoadObjectsWithSkriv = (roadObjectIds: string[], roadSegment: RoadSegment, positions: L.LatLng[], overwriteRoadCategories: string) => LocationalThunk;
export const localizeRoadObjectsWithSkriv: LocalizeRoadObjectsWithSkriv = (roadObjectIds, roadSegment, positions, overwriteRoadCategories) => async (dispatch, getState, serverHolder) => {

    dispatch({
        type: LocationalActionType.ADD_TO_PROGRESS_GOAL,
        progress: 1
    });

    serverHolder.server.localizeFeaturesWithSkriv(serverHolder.contractId, roadObjectIds, roadSegment, positions, overwriteRoadCategories)
        .then(resultList => {
            dispatch({
                type: LocationalActionType.ADD_TO_PROGRESS,
                progress: 1,
            });

            resultList.forEach(result => handleLocalizeResult(result, dispatch));

            dispatch(setAnchorPoint(AnchorPoint.start, null));
            dispatch(setAnchorPoint(AnchorPoint.end, null));

        })
        .catch(() => {
            dispatch({
                type: LocationalActionType.ADD_TO_PROGRESS,
                progress: 1
            });
            dispatch(showErrorMessage("Det oppstod en feil med stedfesting av vegobjekter. Prøv å last inn siden på nytt."));
        });
};

export type SetUseAnchors = (useAnchors: boolean) => LocationalThunk;
export const setUseAnchors: SetUseAnchors = (useAnchors) => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: LocationalActionType.SET_USE_ANCHORS,
        useAnchors
    })
};

export type SetListenForAnchorPoint = (anchorPoint: AnchorPoint) => LocationalThunk;
export const setListenForAnchorPoint: SetListenForAnchorPoint = (listenForAnchorPoint) => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: LocationalActionType.SET_LISTEN_FOR_ANCHORPOINT,
        listenForAnchorPoint
    })
};

export type SetAnchorPoint = (anchorPoint: AnchorPoint, latlng: LatLng) => LocationalThunk;
export const setAnchorPoint: SetAnchorPoint = (anchorPoint, latlng) => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: LocationalActionType.SET_ANCHOR_POINT,
        anchorPoint,
        latlng,
    })
};

export type AutoLocalize = (rots: number[]) => LocationalThunk;
export const autoLocalize: AutoLocalize = (rots) => async (dispatch, getState, serverHolder) => {
    // Add a singe item to get progress right away
    dispatch({
        type: LocationalActionType.ADD_TO_PROGRESS_GOAL,
        progress: 1
    });

    serverHolder.server.startAutoLocalize2(serverHolder.contractId, rots).then(count => {
        if (count === 0) {
            // Server reports "nothing to do", probably because all locationals for types were already approved
            dispatch({
                type: LocationalActionType.ADD_TO_PROGRESS,
                progress: 1
            });
            dispatch(
                showInfoMessage("Utvalget har allerede gyldig stedfesting, ingen stedfesting er endret")
            );
        } else {
            dispatch({
                type: LocationalActionType.ADD_TO_PROGRESS_GOAL,
                progress: count
            });

            startAutolocalizePoller(count, serverHolder, dispatch);
        }
    })
};

export type SetAutoLocalizeModalVisibility = (visible: boolean) => LocationalThunk;
export const setAutoLocalizeModalVisibility: SetAutoLocalizeModalVisibility = (visible) => (dispatch) => {
    dispatch({
        type: LocationalActionType.SET_AUTO_LOCALIZE_MODAL_VISIBILITY,
        showAutoLocalizeModal: visible
    });
}

export type SetFeatureInDetailsModal = (featureId: string) => LocationalThunk;
export const setFeatureInDetailsModal: SetFeatureInDetailsModal = (featureId) => (dispatch) => {
    dispatch({
        type: LocationalActionType.SET_FEATURE_IN_DETAILS_MODAL,
        detailsModalFeatureId: featureId
    });
}

const startAutolocalizePoller = (totalCount: number, serverHolder: ServerHolder, dispatch: ThunkDispatch<LocationalState, ServerHolder, AnyAction>) => {
    dispatch({
        type: LocationalActionType.ADD_TO_PROGRESS,
        progress: 1
    });

    const pollDelay = 1000;
    let poller = setTimeout(function poll(lastActiveCount: number) {
        serverHolder.server.getPendingAutoLocalizingCount(serverHolder.contractId)
            .then(async (count) => {
                if (count !== lastActiveCount) {
                    // Update on change
                    dispatch({
                        type: LocationalActionType.ADD_TO_PROGRESS,
                        progress: lastActiveCount - count
                    });
                    // Check if final state
                    if (count === 0) {
                        dispatch(getRoadObjects(serverHolder.contractId));
                        dispatch(
                            showInfoMessage("Automatisert stedfesting er utført og vegobjektene er oppdatert med status")
                        );
                    } else {
                        poller = setTimeout(poll, pollDelay, count);
                    }
                } else{
                    poller = setTimeout(poll, pollDelay, lastActiveCount);
                }
            })
    }, pollDelay, totalCount)
};

export type ApproveLocationals = (roadObjects: LocationalRoadObject[]) => LocationalThunk;
export const approveLocationals: ApproveLocationals = (roadObjects) => async (dispatch, getState, serverHolder) => {

    dispatch({
        type: LocationalActionType.ADD_TO_PROGRESS_GOAL,
        progress: 2,
    });
    dispatch({
        type: LocationalActionType.ADD_TO_PROGRESS,
        progress: 1,
    });

    serverHolder.server.approveLocationals(serverHolder.contractId, roadObjects.map(ro => ro.id))
        .then((result => {

            roadObjects.forEach(ro => {
                ro.locational.confidence = 1;
                dispatch({
                    type: LocationalActionType.UPDATE_ROADOBJECTS,
                    roadObjects: [ro],
                });
                dispatch(
                    toggleSelectedRoadObject(ro.id)
                );
            });

            dispatch({
                type: LocationalActionType.ADD_TO_PROGRESS,
                progress: 1,
            });

        }), reason => {
            dispatch(showErrorMessage("Det oppstod en feil ved godkjenning av stedfestinger. Prøv å last inn siden på nytt"));
            dispatch({
                type: LocationalActionType.ADD_TO_PROGRESS,
                progress: 1,
            });
        });
};

export type ToggleLocationalBackend = () => LocationalThunk;
export const toggleLocationalBackend: ToggleLocationalBackend = () => async (dispatch, getState, serverHolder) => {
    serverHolder.server.toggleFeature("SkrivLocationals")
        .then(result => {
            dispatch({
                type: LocationalActionType.TOGGLE_SKRIV_LOCATIONALS,
                active: result
            });
            // Update global cache for user session
            serverHolder.security.updateToggles(result);
        })
}

export type FetchingPointsFromReference = (fetching: boolean) => LocationalThunk;
export const fetchingPointsFromReference: FetchingPointsFromReference = (fetching) => (dispatch) => {
    dispatch({
        type: LocationalActionType.FETCHING_POINTS_FROM_REFERENCE,
        fetching
    });
}

export type GetPointsFromReference = (a: string, b?: string) => LocationalThunk;
export const getPointsFromReference: GetPointsFromReference = (a, b) => (dispatch, getState,serverHolder) => {
    dispatch(fetchingPointsFromReference(true));
    const refs = b ? [a, b] : [a];
    serverHolder.nvdbapi.getPointsFromReferences(refs)
        .then((results) => {
            batch(() => {
                const [aResult, bResult] = results;
                if(aResult){
                    dispatch(setAnchorPoint(AnchorPoint.start, aResult));
                } else {
                    serverHolder.server.messages.danger("Kunne ikke finne startpunktet, er referansen riktig?");
                }
                if(b && bResult){
                    dispatch(setAnchorPoint(AnchorPoint.end, bResult));
                } else if(b && !bResult) {
                    serverHolder.server.messages.danger("Kunne ikke finne sluttpunktet, er referansen riktig?");
                }
            })
        })
        .finally(() => {
            dispatch(fetchingPointsFromReference(false));
        })
}

export type UpdateSidePosition = (update: SidePositionEdit) => LocationalThunk;
export const updateSidePosition: UpdateSidePosition = (update) => (dispatch, getState, serverHolder) => {
    const contractId = serverHolder.contractId;

    serverHolder.server.updateSidePosition(contractId, [update])
        .then(() => dispatch(getRoadObjects(contractId)),
            err => dispatch(handleError({contractId, update}, 'Det oppstod en feil ved endring av sideposisjon')));
};

export type UpdateLanes = (laneUpdates: LaneUpdate[]) => LocationalThunk;
export const updateLanes: UpdateLanes = (laneUpdates) => (dispatch, getState, serverHolder) => {
    const contractId = serverHolder.contractId;
    serverHolder.server.updateLane(contractId, laneUpdates)
        .then(() => dispatch(getRoadObjects(contractId)),
            err => dispatch(handleError({contractId, laneUpdates}, 'Error updating lane')));
};
